module.exports = __webpack_public_path__ + "83e5bcbeae85e09cbde01a237221028a.png";